export default __webpack_public_path__ + "static/media/manufactory-colombia.dbd53b20.jpg";